import { render, staticRenderFns } from "./icare_people_detail.vue?vue&type=template&id=cc0dbb42&scoped=true&"
import script from "./icare_people_detail.vue?vue&type=script&lang=js&"
export * from "./icare_people_detail.vue?vue&type=script&lang=js&"
import style0 from "./icare_people_detail.vue?vue&type=style&index=0&id=cc0dbb42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0dbb42",
  null
  
)

export default component.exports